import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ExecuteAxios from "../../Components/ExecuteAxios/ExecuteAxios";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import CondText from '../../Components/SideBar/assets/icons/condbot-login.png';
import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import styles from './FormChangePassword.module.css';

const FormChangePassword = () => {
    const [email, setEmail] = useState(null);
    const [codeSent, setCodeSent] = useState(null);
    const [hasToken, setHasTokenChangePassword] = useState(false);
    const [errorStep, setErrorStep] = useState(false);
    const [code, setCode] = useState(null);
    const [password, setPassword] = useState(null);
    const [confirmedPassword, setConfirmedPassword] = useState(null);
    const [loadingPanel, setLoadingPanel] = useState(false);

    let navigate = useNavigate();

    useEffect(() => {
        if (errorStep) {
            setTimeout(() => {
                setErrorStep(false)
            }, 5000)
        }
    }, [errorStep])

    const handleSubmit = async (event) => {
        event.preventDefault();
    };

    const routeChange = (path) => {
        navigate(path);
    };

    async function sendRecoverCode() {
        try {
            setErrorStep(false)
            setLoadingPanel(true)
            const parameters = {
                recordedEmail: email
            }
            const response = await ExecuteAxios.api('post', `/send-email/validate-user/`, parameters)

            if (response == 'CREATED') {
                setCodeSent(true)
            } else {
                setErrorStep(true)
            }
        } catch (error) {
            setErrorStep(true)
            console.log(error)
        } finally {
            setLoadingPanel(false)
        }
    }

    async function validateRecoverCode() {
        try {
            setErrorStep(false)
            setLoadingPanel(true)
            const parameters = {
                recordedEmail: email,
                code: code
            }
            const response = await ExecuteAxios.api('post', `/send-email/confirm-email/`, parameters)

            if (response == 'CREATED') {
                setHasTokenChangePassword(true)
            } else {
                setErrorStep(true)
            }
        } catch (error) {
            setErrorStep(true)
            console.log(error)
        } finally {
            setLoadingPanel(false)
        }
    }

    async function changePassword() {
        try {
            setLoadingPanel(true)
            const parameters = {
                password: password,
                confirmedPassword: confirmedPassword,
                recordedEmail: email
            }
            const response = await ExecuteAxios.api('post', `/send-email/change-password/`, parameters)

            if (response == 'CREATED') {
                alert('Senha alterada com sucesso!');
                setEmail(null)
                setPassword(null)
                setConfirmedPassword(null)
                setCode(null)
                setErrorStep(null)
                routeChange('/login')
            } else {
                setPassword('')
                setConfirmedPassword('')
                setErrorStep(true)
            }
        } catch (error) {
            setErrorStep(true)
            console.log(error)
        } finally {
            setLoadingPanel(false)
        }
    }

    const searchYourAccountPanel = () => (
        <>
            <LoadingIndicator loaded={!loadingPanel}>

                <h2 className={styles.title}>Recupere sua conta</h2>
                <form className={styles.form} onSubmit={handleSubmit}>
                    <p className={styles.description}>
                        Insira seu e-mail para receber o código de recuperação de senha.
                    </p>
                    <input
                        className={styles.input}
                        placeholder="Email"
                        type="email"
                        value={email || ''}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {errorStep && <span className={styles.error}>E-mail não encontrado no sistema</span>}
                    <div className={styles.actions}>
                        <button onClick={sendRecoverCode} className={styles.button} type="submit">Enviar</button>
                        <button onClick={() => routeChange('/login')} className={styles.cancel} type="button">Cancelar</button>
                    </div>
                </form>
            </LoadingIndicator>
        </>
    );

    const insertYourCodePanel = () => (
        <>
            <h2 className={styles.title}>Insira o código de segurança</h2>
            <form className={styles.form} onSubmit={handleSubmit}>
                <p className={styles.description}>
                    Enviamos um código de 6 dígitos para o e-mail informado caso esteja cadastrado no sistema. Insira-o abaixo.
                </p>
                <input
                    className={styles.input}
                    placeholder="Código"
                    type="text"
                    value={code || ''}
                    onChange={(e) => setCode(e.target.value)}
                />
                <div className={styles.actions}>
                    <button onClick={validateRecoverCode} className={styles.button} type="submit">Confirmar</button>
                    <button onClick={() => routeChange('/login')} className={styles.cancel} type="button">Cancelar</button>
                </div>
            </form>
        </>
    );

    const changePasswordPanel = () => (
        <>
            <h2 className={styles.title}>Altere sua senha</h2>
            <form className={styles.form} onSubmit={handleSubmit}>
                <p className={styles.description}>
                    Crie uma nova senha segura e confirme abaixo.
                </p>
                <input
                    className={styles.input}
                    placeholder="Nova senha"
                    type="password"
                    value={password || ''}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <input
                    className={styles.input}
                    placeholder="Confirme a nova senha"
                    type="password"
                    value={confirmedPassword || ''}
                    onChange={(e) => setConfirmedPassword(e.target.value)}
                />
                {errorStep && <span className={styles.error}>Senhas não conferem ou erro ao alterar</span>}
                <div className={styles.actions}>
                    <button onClick={changePassword} className={styles.button} type="submit">Alterar</button>
                    <button onClick={() => routeChange('/login')} className={styles.cancel} type="button">Cancelar</button>
                </div>
            </form>
        </>
    );

    const getPanelStep = () => {
        if (!codeSent) {
            return (
                <>
                    {searchYourAccountPanel()}
                </>
            )
        } else if (codeSent && !hasToken) {
            return (
                <>
                    {insertYourCodePanel()}
                </>
            )
        } else if (hasToken) {
            return (
                <>
                    {changePasswordPanel()}
                </>
            )
        }

    }

    return (
        <LayoutDefault>
            <div className={styles.imageContent}>
                <img src={CondText} alt="Imagem explicativa sobre o CondoBot" className={styles.imageImg} />
            </div>
            <div className={styles.textContent}>
                <div className={styles.loginPanel}>
                    {getPanelStep()}
                </div>
            </div>
        </LayoutDefault >
    );
}

export default FormChangePassword;
